import { Tabs } from 'antd'
import { useState, useEffect } from 'react'
import OnDemandRoutesList from './OnDemandRoutesList'
import JobsContent from './JobsContent'
import { ScheduleCreateEventFilters } from './scheduleCreateEventModel'
import { SchedulingJob } from '../scheduleApi'
import { Dayjs } from 'dayjs'

type Props = {
  filters: ScheduleCreateEventFilters
  onEventCreated?: () => void
  initialTab?: string
  selectedDate?: Dayjs
  onJobSelected?: (job: SchedulingJob) => void
}

const CreateEventDrawerContent = ({ filters, onEventCreated, initialTab = '1', selectedDate, onJobSelected }: Props) => {
  const [activeTab, setActiveTab] = useState(initialTab)

  useEffect(() => {
    setActiveTab(initialTab)
  }, [initialTab])

  return (
    <Tabs
      activeKey={activeTab}
      onChange={setActiveTab}
      destroyOnHidden
      style={{ backgroundColor: 'white', borderRadius: '8px' }}
      tabBarStyle={{ padding: '0 12px', marginBottom: 8 }}
      items={[
        {
          key: '1',
          label: 'Jobs',
          children: <div style={{ backgroundColor: 'white' }}>
            <JobsContent filters={filters} onEventCreated={onEventCreated} selectedDate={selectedDate} onJobSelected={onJobSelected} />
          </div>
        },
        {
          key: '2',
          label: 'On-Demand Routes',
          children: <div style={{ backgroundColor: 'white' }}>
            <OnDemandRoutesList filters={filters} onEventCreated={onEventCreated} selectedDate={selectedDate} />
          </div>
        }
      ]}
    />
  )
}

export default CreateEventDrawerContent